import styled from 'styled-components';
import {JackpotAmountPreviewDefaultBox} from './jackpot-amount-preview.default.box';
import {Color} from '../../../../../../../themes/definitions/casino777/casino777-colors';

export const JackpotAmountPreviewCasino777Box = styled(JackpotAmountPreviewDefaultBox)`
    text-shadow: 3px 3px 0 ${props => props.theme.colors.bodyText}, 0 0 0 ${props => props.theme.colors.bodyText}, 1px 1px 0 ${props => props.theme.colors.bodyText}, 2px 2px 0 ${props => props.theme.colors.bodyText}, 0 0 0 ${props => props.theme.colors.bodyText};
    color: ${Color.papaya};
    -webkit-text-stroke-width: .5px;
    -webkit-text-stroke-color: ${props => props.theme.colors.bodyText};
`;
